import React, { useEffect, useState } from 'react';
import { verifyOnboarding } from '../api/stripe.api';

export default function OnboardingComplete() {
  const [status, setStatus] = useState('loading');
  const [accountInfo, setAccountInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function verify() {
      try {
        // Get account ID from URL query params
        const urlParams = new URLSearchParams(window.location.search);
        const accountId = urlParams.get('account');

        const result = await verifyOnboarding(accountId);
        setAccountInfo(result);

        if (result.onboardingComplete) {
          setStatus('success');
          // Redirect to guest page after 3 seconds
          setTimeout(() => {
            window.location.href = '/myguest';
          }, 3000);
        } else {
          setStatus('incomplete');
        }
      } catch (err) {
        setError(
          err?.response?.data?.error ||
            err?.message ||
            'Failed to verify onboarding status',
        );
        setStatus('error');
      }
    }

    verify();
  }, []);

  if (status === 'loading') {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body text-center py-5">
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p>Verifying your Stripe account setup...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="alert alert-danger">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  <strong>Error</strong>
                  <p className="mb-0 mt-2">{error}</p>
                </div>
                <a href="/myguest" className="btn btn-secondary">
                  Go to Host Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'incomplete') {
    const missingRequirements = [];
    if (!accountInfo?.chargesEnabled) {
      missingRequirements.push('Enable charges');
    }
    if (!accountInfo?.detailsSubmitted) {
      missingRequirements.push('Submit account details');
    }
    if (!accountInfo?.payoutsEnabled) {
      missingRequirements.push('Enable payouts');
    }

    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="fas fa-info-circle text-info me-2"></i>
                  Setup Incomplete
                </h5>
                <p className="card-text">
                  Your Stripe Connect account setup is not yet complete. Please
                  complete the following requirements:
                </p>
                <ul>
                  {missingRequirements.map((req, idx) => (
                    <li key={idx}>{req}</li>
                  ))}
                </ul>
                <a
                  href="/myguest"
                  className="btn btn-primary"
                  onClick={e => {
                    e.preventDefault();
                    window.location.href = '/myguest';
                  }}
                >
                  Return to Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Success
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body text-center">
              <div className="mb-4">
                <i
                  className="fas fa-check-circle text-success"
                  style={{ fontSize: '4rem' }}
                ></i>
              </div>
              <h4 className="card-title">Setup Complete!</h4>
              <p className="card-text">
                Your Stripe Connect account has been successfully set up. You
                can now receive direct payouts when guests pay for hosting.
              </p>
              <div className="alert alert-success mt-3">
                <strong>What&apos;s next?</strong>
                <p className="mb-0 mt-2">
                  Payments will be automatically transferred to your connected
                  account after each successful booking.
                </p>
              </div>
              <p className="text-muted small mt-3">
                Redirecting to your dashboard...
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

OnboardingComplete.propTypes = {};
